import i18n from '@/i18n/i18n.js'

const { t } = i18n.global

export const HOLIDAY_TYPE = {
  PUBLIC_HOLIDAY: 'public-holiday',
  NON_MATURITY_DAY: 'non-maturity-day',
  NON_RETAILER_PAYMENT_DAY: 'non-retailer-payment-day'
}

export const HOLIDAY_TYPE_MAP = {
  'public-holiday': t('constants.holiday_type.public_holiday'),
  'non-maturity-day': t('constants.holiday_type.non_maturity_day'),
  'non-retailer-payment-day': t('constants.holiday_type.non_retailer_payment_day')
}